'use strict';
import {Dialog} from './dialog.js';
export class DialogPaplan extends Dialog {
	
	constructor(component_key) {
		super(component_key);
	}
	init() {
		super.init();
		this.add_events();
	}
	get track() {
	
	}
	add_events() {
		super.add_events();
	}
	on_show() {
	
	}
	
	on_close() {
		jQuery('html').removeClass('js-no_scroll');
	}
	
}
